<template>
  <div class="col-md-6">
    <div class="form-group">
      <label>{{ $t('gestiune.integrationsFields.platform_status_polling_enabled') }}</label>
      <div>
        <p-switch
          :value="Boolean(formData.platform_status_polling_enabled)"
          :disabled="disabled"
          type="success"
          class="mar-bt-0"
          @input="setEnabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PSwitch from 'src/components/UIComponents/Switch.vue'

export default {
  name: 'IntegrationStatusPollingField',
  components: { PSwitch },
  props: {
    formData: { type: Object, required: true },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    setEnabled (value) {
      if (!this.disabled) {
        this.$set(this.formData, 'platform_status_polling_enabled', Boolean(value))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/IntegrationStatusPollingField.vue